import { baseurl } from './baseurl';
import makeRequest from './makeRequest';

export const AuthApi = {
  login: async (login: string, password: string) => {
    const { data } = await makeRequest<{
      token: string;
      expires: string;
      name: string;
    }>({
      method: 'post',
      url: baseurl + '/auth',
      data: {
        login,
        password,
      },
    });
    return data;
  },
};
